<template>
  <div class="container_box">
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button class="mr15" type="primary" @click="openContainerSettings('add')"
        v-if="getPermission('ymsContainerType_insert')">{{ $t('key1001340') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="650"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--新增容器类型弹窗-->
    <Modal v-model="containerSettingsModal" :title="$t('key1002200')" width="500"
      :transfer="false" :mask-closable="false" @on-visible-change="containerSettingsChange">
      <Form ref="containerSettingsForm" :model="containerSettingsForm" :rules="ruleValidate" :label-width="100" @submit.native.prevent>
        <Row style="width: 85%;">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002201')" prop="name">
              <Input v-model.trim="containerSettingsForm.name" clearable :placeholder="$t('key1002202')"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002203')" prop="weight">
              <InputNumber :max="99999999" :min="0" v-model="containerSettingsForm.weight" style="width: 100%;" :placeholder="$t('key1000324')"></InputNumber>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002204')" prop="volume">
              <InputNumber :max="99999999" :min="0" v-model="containerSettingsForm.volume" style="width: 100%;" :placeholder="$t('key1000324')"></InputNumber>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002205')" prop="length">
              <InputNumber :max="99999999" :min="0" v-model="containerSettingsForm.length" style="width: 100%;" :placeholder="$t('key1000324')"></InputNumber>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002206')" prop="width">
              <InputNumber :max="99999999" :min="0" v-model="containerSettingsForm.width" style="width: 100%;" :placeholder="$t('key1000324')"></InputNumber>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002207')" prop="height">
              <InputNumber :max="99999999" :min="0" v-model="containerSettingsForm.height" style="width: 100%;" :placeholder="$t('key1000324')"></InputNumber>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001495')" prop="remarks">
              <Input type="textarea"
                :showWordLimit="true"
                :maxlength="50"
                :autosize="{ minRows: 4, maxRows: 6}"
                v-model.trim="containerSettingsForm.remarks">
              </Input>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <Button @click="containerSettingsModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="containerSettingsBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: "containerSettings",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      containerTypeList: [],
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002188'),
          key: 'name',
          minWidth: 200,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002189'),
          key: 'weight',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002190'),
          key: 'volume',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002191'),
          key: 'length',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002192'),
          key: 'width',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002193'),
          key: 'height',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350'),
          key: 'remarks',
          width: 300,
          align: 'center',
          render(h, params) {
            return v.checkContentOverflow(h, params.row.remarks, 300, 2);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 160,
          align: 'center',
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsContainerType_update'),
                    clickFn: () => {
                      v.openContainerSettings('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: v.getPermission('ymsContainerType_delete'),
                    clickFn: () => {
                      v.deleteContainerSettingsBtn(params.row.ymsContainerTypeId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      editType: 'add',
      containerSettingsModal: false,
      containerSettingsForm: {
        name: null,
        weight: null,
        volume: null,
        length: null,
        width: null,
        height: null,
        remarks: ''
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002194'),
            trigger: 'blur'
          }
        ],
        weight: [
          {
            required: true,
            type: 'number',
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002195'),
            trigger: 'change'
          }
        ],
        volume: [
          {
            required: true,
            type: 'number',
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002196'),
            trigger: 'change'
          }
        ],
        length: [
          {
            required: true,
            type: 'number',
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002197'),
            trigger: 'change'
          }
        ],
        width: [
          {
            required: true,
            type: 'number',
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002198'),
            trigger: 'change'
          }
        ],
        height: [
          {
            required: true,
            type: 'number',
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002199'),
            trigger: 'change'
          }
        ]
      }
    };
  },
  created() {
    this.search();
  },
  methods: {
    // 查询按钮
    search() {
      this.pageParamsStatus = true;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      if (v.getPermission('ymsContainerType_query')) {
        v.tableLoading = true;
        v.axios.get(api.get_ymsContainerType_query).then(response => {
          if (response.data.code === 0) {
            v.tableData = response.data.datas || [];
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    openContainerSettings(type, data) {
      this.editType = type;
      if (type === 'edit') {
        this.$nextTick(() => {
          this.containerSettingsForm = Object.assign(this.containerSettingsForm, data);
        });
      }
      this.containerSettingsModal = true;
    },
    // 删除容器属性
    deleteContainerSettingsBtn(ymsContainerTypeId) {
      let v = this;
      v.isDelModal(() => {
        v.axios.delete(api.delete_ymsContainerType + ymsContainerTypeId).then((response) => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000779'));
            v.getList();
          }
        });
      });
    },
    // 容器属性弹窗确定按钮
    containerSettingsBtn() {
      let v = this;
      v.$refs['containerSettingsForm'].validate((valid) => {
        if (valid) {
          let apiUrl = null;
          let apiType = 'post';
          let params = JSON.parse(JSON.stringify(v.containerSettingsForm));
          if (v.editType === 'add') {
            apiUrl = api.post_ymsContainerType;
          } else if (v.editType === 'edit') {
            apiUrl = api.put_ymsContainerType;
            apiType = 'put';
          }
          v.axios[apiType](apiUrl, params).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
              v.containerSettingsModal = false;
              v.search();
            }
          });
        }
      });
    },
    // 监听容器属性弹窗
    containerSettingsChange(value) {
      if (!value) {
        this.$refs['containerSettingsForm'].resetFields();
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>

<style scoped>

</style>
